import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Capacitor } from '@capacitor/core';

/**
 * Native-only: navigates home once the Ximi SSO sign-in succeeds. The sign-in itself
 * (open in-app webview, intercept redirect, signinCallback) is driven by
 * useXimiSSOAuth.login → openXimiAuthBrowser. No-op on web (the /ximi/sso route
 * handles that case).
 */
export function useXimiNativeAuth(): void {
    const auth = useAuth();
    const history = useHistory();

    useEffect(() => {
        if (!Capacitor.isNativePlatform()) return;
        if (auth.isAuthenticated) history.replace('/home');
    }, [auth.isAuthenticated, history]);
}
